import React, { Component, Fragment } from "react";
import "moment/locale/fr";
import ImportMetier from "./ImportMetier";
import List from "../../../components/list/List";

class MetierList extends Component {
  render() {
    return (
      <div className="p-content-page-center p-content-page-center-full">
        <div className="p-content-page-center-header">
          <h2 className="p-content-page-center-header-title">Référentiel métier</h2>
        </div>
        <div className="p-content-page-center-content">
          <ImportMetier {...this.props} />
        </div>
      </div>
    );
  }
}

export default MetierList;



// WEBPACK FOOTER //
// src/containers/admin/metier/MetierList.js